'use client'
import UmaLogo from '@/shared/components/UmaLogo/UmaLogo'
import { IPatient } from '@umahealth/entities'
import React, { useEffect } from 'react'
import Bullet from '../components/assets/icons/Bullet'
import ButtonCustom from '@/shared/components/ButtonCustom'
import Cookies from 'js-cookie'
import { useRouter } from 'next/navigation'
import posthog from 'posthog-js'
import { suscriptionEvents } from '@/events/subscriptionsEvents'

const PromoSubsLastMonth = ({ patient }: { patient: IPatient }) => {
    const router = useRouter()

    useEffect(() => {
        suscriptionEvents.promoHomeForApril({
            status: 'opened'
        })
    }, [])
    
    const handleMaybeLater = () => {
        suscriptionEvents.promoHomeForApril({
            status: 'dismiss'
        })
        const inThreeDays = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)
        Cookies.set('promo_subs_last_seen', inThreeDays.toISOString(), {
          path: '/',
          expires: 3,
        })
        router.refresh()
    }

    const handleActivatePromo = () => {
        suscriptionEvents.promoHomeForApril({
            status: 'activate'
        })
        router.push('/checkout/2c9380849445c664019446feb94200cf')
    }

  return (
    <div className='p-6 relative h-full w-full'>
        <div className='flex items-center gap-2'>
            <UmaLogo width={50}/> |
            <p className='text-xxs'>Salud <br/> y bienestar digital</p>
        </div>
        <h1 className='text-[24px] mt-6'>
            ¡<b>{patient.chosenName || patient.firstname}</b>, no dejes pasar esta oportunidad!
        </h1>
        <div className='relative flex flex-col my-10 w-full border border-solid border-2 border-[#00B186] rounded-md gap-2 p-4'>
            <div className='absolute text-xxs p-2 right-2 top-[-20px] text-white font-bold rounded-md bg-[#7135BF]'>
                ÚLTIMAS SEMANAS
            </div>
            <p className='text-xxs text-[#00B186]'>Para vos y tu grupo familiar</p>
            <p className='mb-4 font-bold'>Guardia Premium</p>
            <div className='flex gap-2 items-center'>
                <Bullet/>
                <p className='text-xs text-[#5B2B99]'>
                    5 guardias médicas online <span className='text-[#546E7A] text-xxs'>x mes</span>
                </p>
            </div>
            <div className='flex gap-2 items-center text-[#5B2B99]'>
                <Bullet/>
                <p className='text-xs'>
                    Prioridad en atención
                </p>
            </div>
            <div className='flex gap-2 items-center text-[#5B2B99]'>
                <Bullet/>
                <p className='text-xs'>
                    20% off laboratorios Rapella
                </p>
            </div>
            <p className='mt-4 text-md font-bold text-[#546E7A]'>
                <span className='text-[#90A4AE]'> <s>$8.350</s></span> $7.850/mes
            </p>
        </div>
        <p className='text-center text-xs text-[#546E7A] my-10'>¡Últimos días para activar tu plan <br/> al precio actual!</p>
        
        {/* * Este bloque se renderiza solo si el feature flag `testing-social-proof` 
        * está activado con el valor `"test"`.
        * 
        * 🔬 Experimento A/B:
        * Se está evaluando si mostrar una prueba social 
        * (en este caso, la cantidad de personas que eligieron la promo)
        * genera mayor conversión en los usuarios.
        */}

        {posthog.getFeatureFlag('testing-social-proof') === 'test' && (      
            <div className='flex justify-center mt-6 bg-[#baf7e8] rounded-md gap-2 p-4'>
                <p className='text-[#00B186] font-bold text-xxs'>+3126 personas eligieron esta promoción</p>
            </div>
        )}
        <div className='flex flex-col gap-2 mt-10'>
            <ButtonCustom onClick={handleActivatePromo}>
                ¡Quiero la promo!
            </ButtonCustom>
            <ButtonCustom variant='text' onClick={handleMaybeLater}>
                Quizás más tarde
            </ButtonCustom>
        </div>
    </div>
  )
}

export default PromoSubsLastMonth